const normalizeStatus = (status = "") =>
  String(status).toLowerCase().trim().replace(/\s+/g, " ");

export const isCancelBookingDisabled = (booking) => {
  if (!booking) return false;

  const status = normalizeStatus(booking.status);
  if (status === "gallery delivery" || status === "completed") {
    return true;
  }

  if (booking.isGalleryPublished === true) {
    return true;
  }

  return false;
};

export const shouldShowCancelNoRefundWarning = (booking) => {
  if (!booking || isCancelBookingDisabled(booking)) {
    return false;
  }

  if (booking.hasUnpublishedPhotographerMedia === true) {
    return true;
  }

  const hasUploadSignal = Boolean(
    booking.firstPhotoUploadedAt ||
      booking.photosUploadedAt ||
      normalizeStatus(booking.galleryStatus) === "photos uploaded"
  );

  return hasUploadSignal && booking.isGalleryPublished !== true;
};
